import React from "react";
import { Box, Grid } from "@material-ui/core";

import { Layout, Section } from "../components";

function USCFilmsWeb() {
  return (
    <Layout>
      <Box my={12}>
        <Section>
          <Box className="projectDetails">
            <Box className="banner">USC Films Web App</Box>
            <Box mt={4} className="title">
              Description
            </Box>
            <Box mt={2}>
              <Box my={1}>
                • Developed a full-stack responsive web application using
                Angular 8 and Bootstrap and an iOS application using SwiftUI.
              </Box>
              <Box my={1}>
                • Implemented a backend using Node.js, Express and Flask as a
                CORS proxy server, providing RESTful APIs by querying and
                parsing data from TMDB database.
              </Box>
              <Box my={1}>
                • Developed a web application to display movies and TV shows by
                categories, searched details of movies and shows by consuming
                backend APIs and caching user’s watchlists to local storage.
              </Box>
              <Box my={1}>
                • Ported all functionalities from the web application to an iOS
                application and added supports for gestures and dark mode.
              </Box>
              <Box my={1}>
                • Deployed the web application to Google Cloud Platform and the
                backend to AWS Elastic Beanstalk.
              </Box>
            </Box>
            <Box mt={4} className="title">
              Tech Stacks
            </Box>
            <Box mt={1}>
              JavaScript (ES6), HTML5, CSS3, Angular 8, Boostrap, NG Boostrap,
              RxJS, Google Cloud Platform, VS Code
            </Box>
            {/* <Box mt={4} className="title">
              Demo
            </Box> */}
          </Box>
        </Section>
      </Box>
    </Layout>
  );
}

export default USCFilmsWeb;
